// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gantt-wrap { display: flex; flex-direction: column; height: 100%; overflow: hidden; }

/* Toolbar */
.gantt-zoom-btns { display: flex; gap: 2px; }
.gantt-zoom-btn {
  padding: 3px 10px; font-size: 12px; border-radius: 2px;
  background: var(--bg-tertiary); color: var(--text-secondary);
  border: 1px solid var(--border); cursor: pointer;
}
.gantt-zoom-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }
.gantt-zoom-btn:hover:not(.active) { background: var(--bg-active); color: var(--text-primary); }

/* New/edit form */
.gantt-new-form {
  flex-shrink: 0;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  max-height: 320px;
}
.gantt-new-form-title { font-size: 12px; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.06em; }
.gantt-input { background: var(--bg-input); border: 1px solid var(--border); border-radius: 2px; color: var(--text-primary); font-size: 13px; padding: 4px 8px; width: 100%; outline: none; font-family: inherit; }
.gantt-input:focus { border-color: var(--accent-light); }
.gantt-edit-row { display: flex; gap: 12px; flex-wrap: wrap; }
.gantt-edit-row label { display: flex; flex-direction: column; gap: 3px; font-size: 11px; color: var(--text-secondary); flex: 1; min-width: 100px; }
.gantt-color-row { display: flex; gap: 5px; margin-top: 4px; flex-wrap: wrap; }
.gantt-color-btn { width: 18px; height: 18px; border-radius: 3px; border: 2px solid transparent; cursor: pointer; padding: 0; }
.gantt-color-btn.active { border-color: #fff; }
.gantt-dep-list { display: flex; flex-wrap: wrap; gap: 6px 16px; margin-top: 4px; padding: 6px; background: var(--bg-primary); border: 1px solid var(--border); border-radius: 3px; max-height: 80px; overflow-y: auto; }
.gantt-dep-item { display: flex; align-items: center; gap: 5px; font-size: 12px; color: var(--text-primary); cursor: pointer; }

/* Body */
.gantt-body { flex: 1; overflow: auto; position: relative; cursor: grab; }
.gantt-body:active { cursor: grabbing; }
.gantt-scroll-area { position: relative; display: flex; flex-direction: column; }

/* ── Left column grid (160 | 90 | 86 | 86 | 38 | 72) ── */
.gantt-left-hdr,
.gantt-left-cell {
  display: grid;
  grid-template-columns: 160px 86px 86px 38px 72px;
  align-items: center;
  padding: 0;
}

/* Header row */
.gantt-hdr-row {
  display: flex;
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--bg-secondary);
  border-bottom: 2px solid var(--border);
}
.gantt-left-hdr {
  position: sticky;
  left: 0;
  z-index: 12;
  background: var(--bg-secondary);
  border-right: 2px solid var(--border);
  flex-shrink: 0;
}
.gantt-left-hdr span {
  padding: 0 8px;
  font-size: 10px;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gantt-timeline-hdr {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

/* Month row (top) */
.gantt-hdr-months {
  position: relative;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.gantt-month-label {
  position: absolute;
  top: 0; bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 8px;
  font-size: 11px;
  color: var(--text-secondary);
  font-weight: 600;
  border-right: 1px solid var(--border);
  white-space: nowrap;
  overflow: hidden;
}

/* Sub-unit row (bottom) — days or weeks */
.gantt-hdr-subs {
  position: relative;
  flex: 1;
}
.gantt-sub-label {
  position: absolute;
  top: 0; bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: var(--text-muted);
  border-right: 1px solid rgba(62,62,66,0.5);
  white-space: nowrap;
  overflow: hidden;
  user-select: none;
}
.gantt-sub-we   { background: rgba(255,255,255,0.04); color: var(--text-muted); opacity: 0.7; }
.gantt-sub-mon  { border-right-color: var(--border); font-weight: 700; color: var(--text-secondary); }

/* Task rows */
.gantt-row { display: flex; border-bottom: 1px solid var(--border); }

.gantt-left-cell {
  position: sticky;
  left: 0;
  z-index: 5;
  background: var(--bg-secondary);
  border-right: 2px solid var(--border);
  flex-shrink: 0;
}
.gantt-left-cell > * {
  padding: 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}
.gantt-task-name  { font-weight: 500; color: var(--text-primary); padding: 0 8px !important; }
.gantt-today-line {
  position: absolute;
  width: 1px;
  background: var(--red, #f44747);
  opacity: 0.75;
  pointer-events: none;
  z-index: 4; /* below sticky left panel (z-index: 5) so it hides behind it when scrolled */
}
.gantt-task-date  { color: var(--text-secondary); font-size: 11px !important; }
.gantt-task-pct   { color: var(--text-muted); font-size: 11px !important; text-align: right; }
.gantt-row-actions { display: flex; gap: 1px; align-items: center; }
.gantt-row-actions .btn-icon { width: 18px; height: 18px; }

.gantt-timeline-cell { position: relative; overflow: hidden; flex-shrink: 0; }
.gantt-row-bg { position: absolute; top: 0; left: 0; height: 100%; background: transparent; }
.gantt-row-bg-alt { background: rgba(255,255,255,0.015); }

/* Grid lines in rows */
.gantt-sub-tick {
  position: absolute;
  top: 0;
  width: 1px;
  background: rgba(62,62,66,0.4);
}
.gantt-sub-tick-mon { background: rgba(62,62,66,0.9); }
.gantt-weekend-bg {
  position: absolute;
  top: 0;
  background: rgba(255,255,255,0.03);
}

/* Bars */
.gantt-bar {
  position: absolute;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  cursor: default;
  transition: filter 0.1s;
}
.gantt-bar:hover { filter: brightness(1.15); }
.gantt-bar-progress {
  position: absolute;
  left: 0; top: 0; bottom: 0;
  background: rgba(255,255,255,0.25);
  border-radius: 4px 0 0 4px;
  pointer-events: none;
}
.gantt-bar-label {
  position: relative;
  font-size: 11px;
  color: rgba(255,255,255,0.9);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 6px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.4);
  pointer-events: none;
}

/* Dependency arrows */
.gantt-arrows-svg { position: absolute; pointer-events: none; --gantt-arrow: rgba(255,255,255,0.45); }
[data-theme="light"] .gantt-arrows-svg { --gantt-arrow: rgba(0,0,0,0.5); }
.gantt-arrow { fill: none; stroke: var(--gantt-arrow); stroke-width: 1.5; }
.gantt-arrowhead { fill: var(--gantt-arrow); }

@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .gantt-new-form { max-height: 60vh; }
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/Gantt.css"],"names":[],"mappings":"AAAA,cAAc,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,gBAAgB,EAAE;;AAErF,YAAY;AACZ,mBAAmB,aAAa,EAAE,QAAQ,EAAE;AAC5C;EACE,iBAAiB,EAAE,eAAe,EAAE,kBAAkB;EACtD,8BAA8B,EAAE,4BAA4B;EAC5D,+BAA+B,EAAE,eAAe;AAClD;AACA,yBAAyB,yBAAyB,EAAE,WAAW,EAAE,2BAA2B,EAAE;AAC9F,qCAAqC,4BAA4B,EAAE,0BAA0B,EAAE;;AAE/F,kBAAkB;AAClB;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;AACA,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AAC5I,eAAe,2BAA2B,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,aAAa,EAAE,oBAAoB,EAAE;AAClN,qBAAqB,iCAAiC,EAAE;AACxD,kBAAkB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC7D,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,eAAe,EAAE,4BAA4B,EAAE,OAAO,EAAE,gBAAgB,EAAE;AACnJ,mBAAmB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;AAC9E,mBAAmB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,eAAe,EAAE,UAAU,EAAE;AAC9H,0BAA0B,kBAAkB,EAAE;AAC9C,kBAAkB,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE,eAAe,EAAE,YAAY,EAAE,6BAA6B,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACxN,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,0BAA0B,EAAE,eAAe,EAAE;;AAE9H,SAAS;AACT,cAAc,OAAO,EAAE,cAAc,EAAE,kBAAkB,EAAE,YAAY,EAAE;AACzE,qBAAqB,gBAAgB,EAAE;AACvC,qBAAqB,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE;;AAEhF,0DAA0D;AAC1D;;EAEE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM,EAAE,SAAS;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,MAAM,EAAE,SAAS;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA,kBAAkB,kCAAkC,EAAE,wBAAwB,EAAE,YAAY,EAAE;AAC9F,kBAAkB,iCAAiC,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;;AAErG,cAAc;AACd,aAAa,aAAa,EAAE,sCAAsC,EAAE;;AAEpE;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,+BAA+B;EAC/B,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA,oBAAoB,gBAAgB,EAAE,0BAA0B,EAAE,yBAAyB,EAAE;AAC7F;EACE,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,aAAa;EACb,oBAAoB;EACpB,UAAU,EAAE,6EAA6E;AAC3F;AACA,oBAAoB,4BAA4B,EAAE,0BAA0B,EAAE;AAC9E,oBAAoB,wBAAwB,EAAE,0BAA0B,EAAE,iBAAiB,EAAE;AAC7F,qBAAqB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACnE,+BAA+B,WAAW,EAAE,YAAY,EAAE;;AAE1D,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC7E,gBAAgB,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,YAAY,EAAE,uBAAuB,EAAE;AAC5F,oBAAoB,mCAAmC,EAAE;;AAEzD,uBAAuB;AACvB;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,8BAA8B;AAChC;AACA,sBAAsB,8BAA8B,EAAE;AACtD;EACE,kBAAkB;EAClB,MAAM;EACN,kCAAkC;AACpC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;AACA,mBAAmB,wBAAwB,EAAE;AAC7C;EACE,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,kCAAkC;EAClC,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB,oBAAoB,kBAAkB,EAAE,oBAAoB,EAAE,qCAAqC,EAAE;AACrG,yCAAyC,8BAA8B,EAAE;AACzE,eAAe,UAAU,EAAE,0BAA0B,EAAE,iBAAiB,EAAE;AAC1E,mBAAmB,wBAAwB,EAAE;;AAE7C;EACE,kBAAkB,gBAAgB,EAAE;AACtC","sourcesContent":[".gantt-wrap { display: flex; flex-direction: column; height: 100%; overflow: hidden; }\n\n/* Toolbar */\n.gantt-zoom-btns { display: flex; gap: 2px; }\n.gantt-zoom-btn {\n  padding: 3px 10px; font-size: 12px; border-radius: 2px;\n  background: var(--bg-tertiary); color: var(--text-secondary);\n  border: 1px solid var(--border); cursor: pointer;\n}\n.gantt-zoom-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }\n.gantt-zoom-btn:hover:not(.active) { background: var(--bg-active); color: var(--text-primary); }\n\n/* New/edit form */\n.gantt-new-form {\n  flex-shrink: 0;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-secondary);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-y: auto;\n  max-height: 320px;\n}\n.gantt-new-form-title { font-size: 12px; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.06em; }\n.gantt-input { background: var(--bg-input); border: 1px solid var(--border); border-radius: 2px; color: var(--text-primary); font-size: 13px; padding: 4px 8px; width: 100%; outline: none; font-family: inherit; }\n.gantt-input:focus { border-color: var(--accent-light); }\n.gantt-edit-row { display: flex; gap: 12px; flex-wrap: wrap; }\n.gantt-edit-row label { display: flex; flex-direction: column; gap: 3px; font-size: 11px; color: var(--text-secondary); flex: 1; min-width: 100px; }\n.gantt-color-row { display: flex; gap: 5px; margin-top: 4px; flex-wrap: wrap; }\n.gantt-color-btn { width: 18px; height: 18px; border-radius: 3px; border: 2px solid transparent; cursor: pointer; padding: 0; }\n.gantt-color-btn.active { border-color: #fff; }\n.gantt-dep-list { display: flex; flex-wrap: wrap; gap: 6px 16px; margin-top: 4px; padding: 6px; background: var(--bg-primary); border: 1px solid var(--border); border-radius: 3px; max-height: 80px; overflow-y: auto; }\n.gantt-dep-item { display: flex; align-items: center; gap: 5px; font-size: 12px; color: var(--text-primary); cursor: pointer; }\n\n/* Body */\n.gantt-body { flex: 1; overflow: auto; position: relative; cursor: grab; }\n.gantt-body:active { cursor: grabbing; }\n.gantt-scroll-area { position: relative; display: flex; flex-direction: column; }\n\n/* ── Left column grid (160 | 90 | 86 | 86 | 38 | 72) ── */\n.gantt-left-hdr,\n.gantt-left-cell {\n  display: grid;\n  grid-template-columns: 160px 86px 86px 38px 72px;\n  align-items: center;\n  padding: 0;\n}\n\n/* Header row */\n.gantt-hdr-row {\n  display: flex;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: var(--bg-secondary);\n  border-bottom: 2px solid var(--border);\n}\n.gantt-left-hdr {\n  position: sticky;\n  left: 0;\n  z-index: 12;\n  background: var(--bg-secondary);\n  border-right: 2px solid var(--border);\n  flex-shrink: 0;\n}\n.gantt-left-hdr span {\n  padding: 0 8px;\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.gantt-timeline-hdr {\n  position: relative;\n  overflow: hidden;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Month row (top) */\n.gantt-hdr-months {\n  position: relative;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.gantt-month-label {\n  position: absolute;\n  top: 0; bottom: 0;\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  font-size: 11px;\n  color: var(--text-secondary);\n  font-weight: 600;\n  border-right: 1px solid var(--border);\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n/* Sub-unit row (bottom) — days or weeks */\n.gantt-hdr-subs {\n  position: relative;\n  flex: 1;\n}\n.gantt-sub-label {\n  position: absolute;\n  top: 0; bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  color: var(--text-muted);\n  border-right: 1px solid rgba(62,62,66,0.5);\n  white-space: nowrap;\n  overflow: hidden;\n  user-select: none;\n}\n.gantt-sub-we   { background: rgba(255,255,255,0.04); color: var(--text-muted); opacity: 0.7; }\n.gantt-sub-mon  { border-right-color: var(--border); font-weight: 700; color: var(--text-secondary); }\n\n/* Task rows */\n.gantt-row { display: flex; border-bottom: 1px solid var(--border); }\n\n.gantt-left-cell {\n  position: sticky;\n  left: 0;\n  z-index: 5;\n  background: var(--bg-secondary);\n  border-right: 2px solid var(--border);\n  flex-shrink: 0;\n}\n.gantt-left-cell > * {\n  padding: 0 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n}\n.gantt-task-name  { font-weight: 500; color: var(--text-primary); padding: 0 8px !important; }\n.gantt-today-line {\n  position: absolute;\n  width: 1px;\n  background: var(--red, #f44747);\n  opacity: 0.75;\n  pointer-events: none;\n  z-index: 4; /* below sticky left panel (z-index: 5) so it hides behind it when scrolled */\n}\n.gantt-task-date  { color: var(--text-secondary); font-size: 11px !important; }\n.gantt-task-pct   { color: var(--text-muted); font-size: 11px !important; text-align: right; }\n.gantt-row-actions { display: flex; gap: 1px; align-items: center; }\n.gantt-row-actions .btn-icon { width: 18px; height: 18px; }\n\n.gantt-timeline-cell { position: relative; overflow: hidden; flex-shrink: 0; }\n.gantt-row-bg { position: absolute; top: 0; left: 0; height: 100%; background: transparent; }\n.gantt-row-bg-alt { background: rgba(255,255,255,0.015); }\n\n/* Grid lines in rows */\n.gantt-sub-tick {\n  position: absolute;\n  top: 0;\n  width: 1px;\n  background: rgba(62,62,66,0.4);\n}\n.gantt-sub-tick-mon { background: rgba(62,62,66,0.9); }\n.gantt-weekend-bg {\n  position: absolute;\n  top: 0;\n  background: rgba(255,255,255,0.03);\n}\n\n/* Bars */\n.gantt-bar {\n  position: absolute;\n  border-radius: 4px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  cursor: default;\n  transition: filter 0.1s;\n}\n.gantt-bar:hover { filter: brightness(1.15); }\n.gantt-bar-progress {\n  position: absolute;\n  left: 0; top: 0; bottom: 0;\n  background: rgba(255,255,255,0.25);\n  border-radius: 4px 0 0 4px;\n  pointer-events: none;\n}\n.gantt-bar-label {\n  position: relative;\n  font-size: 11px;\n  color: rgba(255,255,255,0.9);\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 6px;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.4);\n  pointer-events: none;\n}\n\n/* Dependency arrows */\n.gantt-arrows-svg { position: absolute; pointer-events: none; --gantt-arrow: rgba(255,255,255,0.45); }\n[data-theme=\"light\"] .gantt-arrows-svg { --gantt-arrow: rgba(0,0,0,0.5); }\n.gantt-arrow { fill: none; stroke: var(--gantt-arrow); stroke-width: 1.5; }\n.gantt-arrowhead { fill: var(--gantt-arrow); }\n\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .gantt-new-form { max-height: 60vh; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
